import {
    TOGGLE_EDIT_BATCH_SELECTION,
    ToggleEditBatchSelectionAction,
    ToggleFetchRegulationPanelAction,
    TOGGLE_FETCH_REGULATION_PANEL,
    FETCH_MATCHING_BATCH_REGULATIONS,
    FetchMatchingBatchRegulationsAction,
    MATCHING_BATCH_REGULATIONS_RECEIVED,
    MatchingBatchRegulationsReceived,
    ToggleFetchRegulationSelectionAction,
    TOGGLE_FETCH_REGULATION_SELECTION
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const toggleEditBatchSelection = createAction<ToggleEditBatchSelectionAction["payload"]>(
    TOGGLE_EDIT_BATCH_SELECTION
);
export const toggleFetchRegulationSelection = createAction<
    ToggleFetchRegulationSelectionAction["payload"]
>(TOGGLE_FETCH_REGULATION_SELECTION);
export const toggleFetchRegulationPanel = createAction<ToggleFetchRegulationPanelAction["payload"]>(
    TOGGLE_FETCH_REGULATION_PANEL
);

export const fetchMatchingBatchRegulations = createAction<
    FetchMatchingBatchRegulationsAction["payload"]
>(FETCH_MATCHING_BATCH_REGULATIONS);

export const matchingBatchRegulationsReceived = createAction<
    MatchingBatchRegulationsReceived["payload"]
>(MATCHING_BATCH_REGULATIONS_RECEIVED);
